import { ActionType } from '../reducers/home';
import { api } from '../config';
import mockData from '../mocks/home.json';

import { isUrlCached, getUrlCache } from '../utils/cache';

export const setHomeData = () => {
  return (dispatch) => {
    const shouldFetchMock = false;
    const fetchType = shouldFetchMock ? 'FETCH_MOCK' : 'FETCH';
    const mockResult = mockData;

    const url = `${api.home}`;
    const method = 'get';
    const headers = {};
    const options = {
      cache: true,
    };

    const cacheUrl = `${url}`;
    if (isUrlCached(cacheUrl)) {
      const urlCache = getUrlCache(cacheUrl);
      if (urlCache.data) {
        return dispatch({
          type: 'IS_CACHED_HOME_DATA',
          payload: urlCache.data,
        });
      }
    }

    const type: ActionType = 'SET_HOME_DATA';
    return Promise.resolve(
      dispatch({
        type,
        fetch: {
          type: fetchType,
          actionTypes: {
            request: 'REQUEST_HOME_DATA',
            success: 'RECEIVED_HOME_DATA',
            fail: 'ERROR_HOME_DATA',
          },
          url,
          // props only used when type = FETCH_MOCK:
          mockResult,
          method,

          headers,
          options,
        },
      }),
    );
  };
};
